var map = {
	"./a.png": 60472,
	"./b.png": 67293,
	"./c.png": 7171,
	"./d.png": 97610,
	"./e.png": 38539,
	"./f.png": 58657,
	"./g.png": 63594,
	"./h.png": 96075,
	"./i.png": 59249,
	"./j.png": 6728,
	"./k.png": 42285,
	"./l.png": 33145,
	"./m.png": 62471,
	"./n.png": 62141,
	"./o.png": 49129,
	"./p.png": 35420,
	"./r.png": 61248,
	"./s.png": 44876,
	"./t.png": 61788,
	"./u.png": 99355,
	"./w.png": 59768,
	"./x.png": 24142,
	"./y.png": 89838,
	"./z.png": 41224,
	"./za.png": 47605,
	"./zb.png": 64351,
	"./zc.png": 22945,
	"./zd.png": 55328,
	"./ze.png": 6372,
	"assets/tables/new/matematyka/a.png": 60472,
	"assets/tables/new/matematyka/b.png": 67293,
	"assets/tables/new/matematyka/c.png": 7171,
	"assets/tables/new/matematyka/d.png": 97610,
	"assets/tables/new/matematyka/e.png": 38539,
	"assets/tables/new/matematyka/f.png": 58657,
	"assets/tables/new/matematyka/g.png": 63594,
	"assets/tables/new/matematyka/h.png": 96075,
	"assets/tables/new/matematyka/i.png": 59249,
	"assets/tables/new/matematyka/j.png": 6728,
	"assets/tables/new/matematyka/k.png": 42285,
	"assets/tables/new/matematyka/l.png": 33145,
	"assets/tables/new/matematyka/m.png": 62471,
	"assets/tables/new/matematyka/n.png": 62141,
	"assets/tables/new/matematyka/o.png": 49129,
	"assets/tables/new/matematyka/p.png": 35420,
	"assets/tables/new/matematyka/r.png": 61248,
	"assets/tables/new/matematyka/s.png": 44876,
	"assets/tables/new/matematyka/t.png": 61788,
	"assets/tables/new/matematyka/u.png": 99355,
	"assets/tables/new/matematyka/w.png": 59768,
	"assets/tables/new/matematyka/x.png": 24142,
	"assets/tables/new/matematyka/y.png": 89838,
	"assets/tables/new/matematyka/z.png": 41224,
	"assets/tables/new/matematyka/za.png": 47605,
	"assets/tables/new/matematyka/zb.png": 64351,
	"assets/tables/new/matematyka/zc.png": 22945,
	"assets/tables/new/matematyka/zd.png": 55328,
	"assets/tables/new/matematyka/ze.png": 6372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16412;